import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-group-filter',
  templateUrl: './user-group-filter.component.html',
  styleUrls: ['./user-group-filter.component.scss'],
})
export class UserGroupFilterComponent  implements OnInit {

  breadcrumbList = [
    {
      label: 'User group',
      embedurl: true,
      url: '/baseapp/user-group'
    },
    {
      label: 'Group filters',
      embedurl: false,
      url: ''
    }
  ];

  userGroupDisplayedColumns: string[] = ['index_name', 'column_name', 'condition_flag', 'column_value', 'column_type','created_date','updated_date', 'action'];
  groupFilterDataSource: any[] = [];
  hide1200 = false;
  loading = true;
  getUserGroupApi: Subscription | undefined;
  groupId: any;
  filteredDataSource: any[] = [];
  searchQuery: string = '';

  constructor(
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    private route: ActivatedRoute,
    public storage: Storage,
    public alertController: AlertController,
    public helperService: HelperService) { }

  ngOnInit() {
    const queryParams = this.route.snapshot.paramMap;
    this.groupId = queryParams.get('id');
    this.getGroupFilters(this.groupId);
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.helperService.closeLoader();
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.getUserGroupApi) {
      this.getUserGroupApi.unsubscribe();
    }
    this.helperService.closeLoader();
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  getGroupFilters(groupId: any) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        group_id : groupId
      }
      this.getUserGroupApi = this.backendService.PostAPICall('getGroupFilterByGroupId', payload, res.token).subscribe(
        data => {
          this.helperService.closeLoader();
          this.groupFilterDataSource = data;
          this.filteredDataSource = this.groupFilterDataSource.slice();
          this.loading = false;
        },
        (error) => {
          //console.log(error);
          this.loading = false;
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  filterDataSource() {
    if (this.searchQuery.trim() === '') {
      this.filteredDataSource = this.groupFilterDataSource.slice();
    } else {
      this.filteredDataSource = this.groupFilterDataSource.filter(item =>
        item.index_name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        item.column_name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        item.column_type.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  }

  clearSearch() {
    this.searchQuery = '';
    this.filterDataSource();
  }

  confirmDelete(userId) {
    const header = 'Confirm!';
    const msg = "Are you sure you want to delete?"
    this.confirmDeleteAlert(header, msg, userId,)
  }

  async confirmDeleteAlert(header, msg, id) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          }
        }, {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteGroupFilter(id)
          }
        }
      ]
    });
    await alert.present();
  }

  deleteGroupFilter(id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let url = `/api/users/deleteGroupFilter/${id}`;
      this.backendService.DeleteAPICall(url, res.token).subscribe(
        (res) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(res.data, 2000);
          this.getGroupFilters(this.groupId);
        },
        (error) => {
          //(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  addGroupFilter(id) {
    this.router.navigate(['baseapp/user-group/add-filter', id])
  }

  editGroupFilter(id) {
    this.router.navigate(['baseapp/user-group/update-filter', id])
  }

  getGroupFilterDetails(id) {
    this.router.navigate(['baseapp/user-group/filter-details', id])
  }

}
